import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-multi-doc',
  templateUrl: './multi-doc.component.html',
  styleUrls: ['./multi-doc.component.css']
})
export class MultiDocComponent implements OnInit {
    docType;

    argType;

    argValue;

    public itemsListMultiDocuments: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.docType = this.stateService.getStateParams()['doctype'];
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadMultiDocuments() {
        if (!!this.docType && !!this.argType && !!this.argValue) {
            this.itemsListMultiDocuments = await this.datatask.Post(505, {
                doctype: this.docType,
                argtype: this.argType,
                argvalue: this.argValue
            });
        }
    }

    private async init() {
        this.loadMultiDocuments();
    }

    ngOnInit() {
        this.init();
    }
}
